<template>
<body>
<!-- <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-T6C8Q4F" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript> -->
<!--DEV Google Tag Manager (noscript) -->
     <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MKSJ39Q" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->
  <div id="app">
   
    <router-view></router-view>
  </div>
</body>
</template>

<script>
// // ======== Google Tag Manager
//  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
// new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
// j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
// 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
// })(window,document,'script','dataLayer','GTM-T6C8Q4F');
// // ======== End Google Tag Manager

//========DEV Google Tag Manager
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MKSJ39Q');
// ======== End Google Tag Manager

export default {
  name: 'app'
}
</script>

<style>
  @import '../static/css/evf-style.css';
  /* @import '../static/css/essilorvision.css';
  @import '../static/css/portal-home-page.css'; */
  @import '../static/css/site-general.css';
  @import '../static/css/bootstrap.min.css';
  @import '../static/assets/css/custom.css';
  @import '../static/css/vue-multiselect.min.css';
  @import '../static/css/swiper.min.css';
</style>






// WEBPACK FOOTER //
// App.vue?7aa6c1b0